import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../../shared/services/loader-service';
import { HttpClientService } from '../../../shared/services/http-client-service';
import { HomeApiResponse } from '../../../core/models/home';
import { StatusSolicitacao } from '../../../core/constants/status-solicitacao';
import { HttpResponse } from '@angular/common/http';
import { ToastService } from '../../../shared/services/toast-service';

@Component({
  imports: [DatePipe],
  selector: 'app-home',
  styleUrl: './home.scss',
  templateUrl: './home.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class Home {
  private readonly router = inject(Router);
  private readonly httpClientService = inject(HttpClientService);
  private readonly loaderService = inject(LoaderService);
  private readonly toastService = inject(ToastService);
  readonly dataLimite = signal<string | undefined>(undefined);
  readonly statusSolicitacao = signal<string | undefined>(undefined);
  readonly dadosCarregados = signal(false);
  readonly openModalRedirecionamento = signal(false);
  readonly fluxoTemporario = signal(false);

  async ngOnInit(): Promise<void> {
    await this.getHomeData();

    // Aguardando reenvio de documentos: vai direto para o upload, sem exibir a home.
    if (this.statusSolicitacao() === StatusSolicitacao.AGUARDANDO_REENVIO) {
      this.router.navigate(['/instituto-online/upload-documentos']);
      return;
    }

    this.dadosCarregados.set(true);

    if (this.statusSolicitacao() === StatusSolicitacao.AGUARDANDO_VALIDACAO_DOCUMENTOS || 
        this.statusSolicitacao() === StatusSolicitacao.FINALIZADO)
      this.openModalRedirecionamento.set(true);
  }

  irParaComprovante() {
    this.router.navigate([this.fluxoTemporario() ? '/instituto-online/detalhes-mvp' : '/instituto-online/detalhes']);
  }

  onSubmit() {
    this.router.navigate(['/instituto-online/extrato-desligamento']);
  }

  private async getHomeData(): Promise<void> {
    
    this.loaderService.showLoader('Carregando...');

    try {
      const data: HttpResponse<HomeApiResponse> = await this.httpClientService.getHomeData();
      this.dataLimite.set(data.body?.dataLimite);
      this.statusSolicitacao.set(data.body?.statusSolicitacao);
      this.fluxoTemporario.set(data.body?.fluxoTemporario ?? false);
    } catch {
      this.router.navigate(['/instituto-online/pagina-indisponivel']);
    } finally {
      this.loaderService.hideLoader();
    }
  }
}
